import '@dynamic-labs/sdk-api';
import { logger } from '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/wallet-book';
import '@dynamic-labs/utils';
import '../../constants/colors.js';
import '../../../shared/utils/classes/storage/localStorage.js';
import 'viem';
import '../../../shared/consts/index.js';

const getRedirectURIOrigin = (url) => {
    var _a;
    try {
        const urlObj = new URL(url);
        const redirectUriStr = (_a = urlObj.searchParams.get('redirect_uri')) !== null && _a !== void 0 ? _a : '';
        const redirectUri = new URL(redirectUriStr);
        return redirectUri.origin;
    }
    catch (e) {
        logger.debug('Failed to get redirect uri origin', e);
        return '';
    }
};

export { getRedirectURIOrigin };
